export function formatRupiah(price) {
  const numberPrice = Number(price);
  if (isNaN(numberPrice)) return "Rp 0";
  return (
    "Rp " +
    numberPrice.toLocaleString("id-ID", {
      maximumFractionDigits: 0,
    })
  );
}
